module.exports = __webpack_public_path__ + "static/media/feature1.fac0a612.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/feature1.svg
 ** module id = 629
 ** module chunks = 0
 **/